import { ChangeDetectionStrategy, Component, Inject, ViewChild } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

import { IInviteUserModel } from '../../invite-user/invite-user-model';
import { InviteUserFormComponent } from '../invite-user-form/invite-user-form.component';
import { RpcButtonComponent } from '../../../../../core-modules/controls/components/rpc-button/rpc-button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'invite-user-dialog',
    templateUrl: './invite-user-dialog.component.html',
    styleUrls: ['./invite-user-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RpcButtonComponent, InviteUserFormComponent, TranslateModule]
})
export class InviteUserDialogComponent {
    @ViewChild(InviteUserFormComponent) private readonly inviteUserFormComponent: InviteUserFormComponent;

    constructor(
        private readonly dialogRef: DialogRef<unknown, InviteUserDialogComponent>,
        @Inject(DIALOG_DATA) public inviteDialogData: { email?: string, portfolioEmails: string[] }
    ) { }

    public get isFormInvalid(): boolean {
        return this.inviteUserFormComponent?.inviteUserFormGroup?.invalid;
    }

    public sendEmail(): void {
        if (this.isFormInvalid) {
            return;
        }

        const inviteUserModel = this.inviteUserFormComponent.inviteUserFormGroup.getRawValue() as IInviteUserModel;

        this.dialogRef.close(inviteUserModel);
    }

    public close(): void {
        this.dialogRef.close();
    }
}
